module.exports = __webpack_public_path__ + "static/img/user7.fca44f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user7.jpg
// module id = BfsD
// module chunks = 23